// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id='customer-deposit-accounts-activate-account' class="box">

  <sub-header header="'Activate account'"></sub-header>
    <form-section>

      <div class="info info--deposit">
        <div class="info-detail">
          <span class="key">Product name:</span>
          <span class="value">{{\$ctrl.depositAccount.productName}}
          </span>
        </div>

        <div class="info-detail">
          <span class="key">Available balance:</span>
          <span class="value"
                ng-class="{'currency--positive': \$ctrl.depositAccount.balance > 0, 'currency--negative': \$ctrl.depositAccount.balance < 0}">
            {{\$ctrl.depositAccount.balance | nxCurrency}}
          </span>
        </div>
      </div>

      <h2 class="section-header">Please confirm the following:</h2>
      <table class="misc-transaction__table table">
        <tbody>
        <tr>
          <td>1.</td>
          <td>Available balance after account activation:</td>
          <td>
            <cash value="\$ctrl.depositAccount.balance"
              ng-required="true"
              ng-disabled="true"></cash>
          </td>
        </tr>
        <tr>
          <td>2.</td>
          <td>Total balance after account activation</td>
          <td>
            <cash value="\$ctrl.depositAccount.balance + \$ctrl.depositAccount.holdsBalance"
              ng-required="true"
              ng-disabled="true"></cash>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button class="btn btn-success" ng-click="\$ctrl.activate()">Activate</button>
      </div>

      <div class="clearfix"></div>
    </form-section>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/activate-account/activate-account.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;